import { render, staticRenderFns } from "./layoutDefault.vue?vue&type=template&id=d388461c"
import script from "./layoutDefault.vue?vue&type=script&lang=js"
export * from "./layoutDefault.vue?vue&type=script&lang=js"
import style0 from "./layoutDefault.vue?vue&type=style&index=0&id=d388461c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports